import { TablePage, EditPage, ViewPage } from 'src/views/compliance/declarantmaintenance'
import pathMap from 'src/paths/PathMap_Compliance'



class DeclarantMaintenanceRoute {
    getConfigurations() {
        return [
            {
                exact: true,
                path: pathMap.DECLARANT_MAINTENANCE_LIST,
                component: TablePage
            },
            {
                exact: true,
                path: pathMap.DECLARANT_MAINTENANCE_EDIT_VIEW,
                component: EditPage
            },
            {
                exact: true,
                path: pathMap.DECLARANT_MAINTENANCE_DETAILS_VIEW,
                component: ViewPage
            }

        ]
    }
}

export default DeclarantMaintenanceRoute